<div class="flex-column flex">
    <ion-button
        [attr.aria-label]="'ADD_NEW_CARD' | translate"
        (click)="navigateToAddNewCard()"
        size="large"
        color="secondary">
        <ion-label class="text-base font-bold normal-case">
            {{ 'ADD_NEW_CARD' | translate }}
        </ion-label>
    </ion-button>
</div>
